export const HourTypeDropDown = (props) => {
    const { 
        index, 
        nameHourType, 
        listHourTypes, 
        valueHourType, 
        setHourType, 
        action,
        className,
        disabled,
    } =
        props;
    return (
        <>
            {listHourTypes && (
                <div className="relative">
                    <select
                        className={className || "appearance-none w-60 bg-gray-200 border border-gray-200 text-gray-700 py-2 px-3 mr-2 rounded-sm leading-tight focus:outline-hidden focus:bg-white focus:border-gray-500"}
                        id="grid-state"
                        key="grid-state"
                        // defaultValue=""
                        value={valueHourType}
                        disabled={disabled === true}
                        onChange={(e) => {
                            if (disabled === true) return;
                            setHourType(e.target.value, index);
                        }}
                        name={nameHourType}
                    >
                        {listHourTypes.map((ht) => {
                            return "content" in ht ? (
                                <optgroup key={ht.name} label={ht.name}>
                                    {ht.content.map((opt) => {
                                        return (
                                            <option key={opt.id} value={opt.id}>
                                                {opt.name}
                                            </option>
                                        );
                                    })}
                                </optgroup>
                            ) : (
                                <option key={ht.id} value={ht.id}>{ht.name}</option>
                            );
                        })}
                    </select>

                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                        <svg
                            className="fill-current h-4 w-4"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                        >
                            <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                        </svg>
                    </div>
                </div>
            )}
        </>
    );
};
